import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import Settings from '../../../../services/settings.service';
import { Link } from 'react-router-dom';
import Translation from '../../../../services/translation.service';
import { urlFormatter } from '../../../../util';

const TEMPORARY_URL_PREFIX = `${Settings.REACT_APP_API_BASE_URL}images`;

const BusinessMobile = ({ toggleNav, toggleNavMain, resetNavList, links }) => {
  let business_link = '';
  let push_to_talk_link = '';

  business_link = urlFormatter(links?.['informative-business']['route']);
  push_to_talk_link = urlFormatter(
    links?.['informative-push_to_talk']['route']
  );

  return (
    <li className="nav-list-itm mobile-tablet-only" style={{ paddingTop: 0 }}>
      <div className="nav-list-lnk pointer light-blue" onClick={toggleNavMain}>
        {Translation.key('b2b_business')}
      </div>
      <div className="sub-nav-wrapper">
        <div className="sub-nav flex-between">
          <div className="back mobile-tablet-only" onClick={resetNavList}>
            <svg
              width="10"
              height="18"
              viewBox="0 0 10 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 17L1.00016 9.00048L9 1.00048"
                stroke="#7C8095"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div class="nav-section nav-section-column">
            <div class="sub-nav-list-lnk">
              <Link onClick={toggleNav} to={business_link}>
              {Translation.key("business_plans_header_title")}
              </Link>
            </div>
            <div class="sub-nav-list-lnk">
              <Link onClick={toggleNav} to={push_to_talk_link}>
                {Translation.key("push_to_talk_header_title")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

const mapStateToProps = (state) => ({
  links: state.layout.routes,
});
export default connect(mapStateToProps)(BusinessMobile);
